import { render } from "./AlertFeed.vue?vue&type=template&id=1c43a3f2&scoped=true&ts=true&lang=pug"
import script from "./AlertFeed.vue?vue&type=script&lang=ts"
export * from "./AlertFeed.vue?vue&type=script&lang=ts"

import "./AlertFeed.vue?vue&type=style&index=0&id=1c43a3f2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c43a3f2"]])

export default __exports__